module.exports = __webpack_public_path__ + "static/media/cross.35a6ccb5.svg";